import React, { useRef, useState, useEffect } from "react";

import SunEditor from "suneditor-react";
import SunEditorCore from "suneditor/src/lib/core";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
import { apiWrapper } from "../../api/apiWrapper";

const defaultFonts = [
  "Arial",
  "Comic Sans MS",
  "Courier New",
  "Impact",
  "Georgia",
  "Tahoma",
  "Trebuchet MS",
  "Verdana",
];
const sortedFontOptions = [
  "Logical",
  "Salesforce Sans",
  "Garamond",
  "Sans-Serif",
  "Serif",
  "Times New Roman",
  "Helvetica",
  ...defaultFonts,
].sort();
interface IMyHtmlEditorProps {
  value: string;
  onValueChanged: (htmlValue: string) => void;
  height?: number;
}
const MyHtmlEditor = (props: IMyHtmlEditorProps) => {
  const { value, height, onValueChanged } = props;
  const editor = useRef<SunEditorCore>();

  const getSunEditorInstance = (sunEditor: SunEditorCore) => {
    editor.current = sunEditor;
  };

  const handleChange = (content: string) => {
    onValueChanged(content);
  };

  const handleImageUploadBefore = (files: File[], info: object, uploadHandler: Function): any => {
    // Upload image to Server
    var file = files ? files[0] : undefined;
    if (file) {
      try {
        apiWrapper.uploadFile.uploadImage(file).then(response => {
          if (response && response.is_success) {
            const imageUrl = response?.data?.url;
            if (imageUrl) {
              // result
              const responseResult = {
                // The response must have a "result" array.
                result: [
                  {
                    url: imageUrl,
                    name: file?.name,
                    size: file?.size,
                  },
                ],
              };
              uploadHandler(responseResult);
            }
          }
        });
      } catch (error) {
        uploadHandler();
      }
    }
  };

  return (
    <div>
      <SunEditor
        getSunEditorInstance={getSunEditorInstance}
        setContents={value}
        onChange={(content) => handleChange(content)}
        onImageUploadBefore={(files, info, uploadHandler) =>
          handleImageUploadBefore(files, info, uploadHandler)
        }

        setOptions={{
          buttonList: [
            ["undo", "redo"],
            ["font", "fontSize"],
            // ['paragraphStyle', 'blockquote'],
            [
              "bold",
              "underline",
              "italic",
              "strike",
              "subscript",
              "superscript",
            ],
            ["fontColor", "hiliteColor"],
            ["align", "list", "lineHeight"],
            ["outdent", "indent"],

            ["table", "horizontalRule", "link", "image", "video"],
            // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
            // ['imageGallery'], // You must add the "imageGalleryUrl".
            // ["fullScreen", "showBlocks", "codeView"],
            ["preview", "print"],
            ["removeFormat"],

            // ['save', 'template'],
            // '/', Line break
          ], // Or Array of button list, eg. [['font', 'align'], ['image']]
          defaultTag: "div",
          // minHeight: "300px",
          height: "auto",
          showPathLabel: false,
          font: sortedFontOptions,
        }}
      />
    </div>
  );
};

export default MyHtmlEditor;
